import React from 'react';
import { ReactComponent as ConsultationIcon } from '../../assets/icons/consultation_encounter_icon.svg';
import { ReactComponent as FollowUpIcon } from '../../assets/icons/follow_up_icon.svg';
import { ReactComponent as SupportIcon } from '../../assets/icons/support_ticket_icon.svg';
import styles from './EncounterIcon.module.css';

export const getEncounterType = (encounter) => {
	if (encounter?.visitType === 'FOLLOWUP') return 'FOLLOWUP';
	if (encounter?.type === 'SUPPORT') return 'SUPPORT';
	return 'CONSULT';
};

const ICON_BY_TYPE = {
	FOLLOWUP: FollowUpIcon,
	SUPPORT: SupportIcon,
	CONSULT: ConsultationIcon,
};

const WRAPPER_CLASS_BY_TYPE = {
	FOLLOWUP: styles.iconWrapperFollowup,
	SUPPORT: styles.iconWrapperSupport,
	CONSULT: styles.iconWrapperConsult,
};

export const EncounterIcon = ({ encounter, unreadCount = 0, className = '' }) => {
	const type = getEncounterType(encounter);
	const Icon = ICON_BY_TYPE[type];

	return (
		<div className={`${styles.iconWrapper} ${WRAPPER_CLASS_BY_TYPE[type]} ${className}`}>
			<Icon className={styles.encounterIcon} />
			{unreadCount > 0 && (
				<span className={styles.unreadDot} aria-label={`${unreadCount} unread`}>
					{unreadCount}
				</span>
			)}
		</div>
	);
};

export default EncounterIcon;
